/**
 * MonacoHtmlEditor — wrapper sobre @monaco-editor/react con lazy
 * loading via React.lazy + Suspense.
 *
 * Monaco es ~3MB; cargarlo lazy mantiene el bundle inicial chico.
 * Solo se importa cuando el usuario abre el editor de plantillas.
 */

import { lazy, Suspense } from 'react'

const Monaco = lazy(() =>
  import('@monaco-editor/react').then((m) => ({ default: m.default })),
)

interface Props {
  value: string
  onChange: (value: string) => void
  height?: string | number
}

export function MonacoHtmlEditor({ value, onChange, height = '70vh' }: Props) {
  return (
    <Suspense
      fallback={
        <div
          style={{ height }}
          className="flex items-center justify-center rounded-md border border-border bg-bg-elevated text-sm text-fg-muted"
        >
          Cargando editor…
        </div>
      }
    >
      <div className="overflow-hidden rounded-md border border-border">
        <Monaco
          height={height}
          defaultLanguage="html"
          value={value}
          onChange={(v) => onChange(v ?? '')}
          theme="vs-dark"
          options={{
            minimap: { enabled: false },
            fontSize: 13,
            lineNumbers: 'on',
            wordWrap: 'on',
            scrollBeyondLastLine: false,
            tabSize: 2,
            renderWhitespace: 'selection',
            automaticLayout: true,
          }}
        />
      </div>
    </Suspense>
  )
}
